export const toRound = (number: falsy | number | string, roundTo = 2) =>
  number ? parseFloat((+number)?.toFixed(roundTo)) : '0';
